import { selectHappyPathWeeksSinceFirstDelivery } from 'src/redux-api-bridge/happy-path/selectors'

export const getLastOrder = state => state.api.subscription.lastOrder

export const shouldShowReviewModalByLastOrderSelector = (
  state,
  forceShowRateMealsModal
) => {
  const weeksSinceFirstDelivery = selectHappyPathWeeksSinceFirstDelivery(state)
  const order = getLastOrder(state)
  const isOrderStructureOk = Boolean(order?.id && order?.items instanceof Array)

  return (
    isOrderStructureOk &&
    (weeksSinceFirstDelivery >= 5 || forceShowRateMealsModal)
  )
}
